import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { formatDateShort } from '../../../../../../constants/dates'

import { START_DATE } from '../../../../../ReusableFormFields/StartTimeFields/fields'
import { STOP_DATE } from '../../../../../ReusableFormFields/StopTimeFields/fields'

const DatesSectionPreview = ({ campaign = {} }) => {
  const { t } = useTranslation()

  const { [START_DATE]: startDate, [STOP_DATE]: endDate } = campaign

  const formattedStartDate = useMemo(() => startDate && formatDateShort(startDate), [startDate])
  const formattedEndDate = useMemo(() => (endDate ? formatDateShort(endDate) : t('Ongoing')), [endDate, t])

  return (
    <p>
      {formattedStartDate}
      {formattedStartDate && formattedEndDate ? ' - ' : null}
      {formattedEndDate}
    </p>
  )
}

export default DatesSectionPreview
